export default "__VITE_ASSET__4d616750__"